// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../index';

import { gql } from 'graphql-tag';
import { RelatedProductFragmentDoc } from '../../../components/rings/RelatedProducts.generated';
import { MetalVariationFragmentDoc } from '../../../components/rings/MetalVariations.generated';
export const CatalogueProductFragmentDoc = gql`
    fragment catalogueProduct on CatalogueProduct {
  __typename
  catalogueCode
  productName
  suffix
  customTitleTag
  relatedProducts {
    ...relatedProduct
  }
  ...metalVariation
}
    ${RelatedProductFragmentDoc}
${MetalVariationFragmentDoc}`;